export enum Level {
  Object = 'Object',
  ObjectDelete = 'ObjectDelete',
  Batch = 'Batch',
  BatchDelete = 'BatchDelete'
}
